import React from 'react';

const SideHead = () => {
    return (
        <div style={{ color: '#082244' }}>
            <h1>
                <strong>EBA</strong> Members’  <br />
                <strong>Directory</strong>
            </h1>
            <p>
                EBA Members’ Directory includes complete<br /> data about its members and their companies  filtered through <br />different search criteria (member name, company name, sector…)
            </p>
        </div>

    )
}

export default SideHead;